import { c as _c } from "react/compiler-runtime";
import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/constants/queryKeys';
import { apiSelfCareFetcher } from '../fetcher';
import { URLS } from '@/constants/api';
type ExchangeRateMarkUp = {
  otherCurrencies: string;
  rubTryCny: string;
};
export function useExchangeRateMarkupsQuery(t0) {
  const $ = _c(8);
  const {
    date
  } = t0;
  let t1;
  if ($[0] !== date) {
    t1 = QUERY_KEYS.ecbExchangeRateMarkups(date);
    $[0] = date;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== date) {
    t2 = async () => {
      const res = await apiSelfCareFetcher(URLS.exchangeRatesMarkups({
        date
      }));
      return res.json;
    };
    $[2] = date;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = !!date;
  let t4;
  if ($[4] !== t1 || $[5] !== t2 || $[6] !== t3) {
    t4 = {
      queryKey: t1,
      queryFn: t2,
      enabled: t3
    };
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return useQuery(t4);
}